import { useState } from 'react';
import Style from './style.js';
import { jsx } from '@emotion/react';

var Tabs = _ref => {
  var {
    initialActiveTabId = 1,
    onClick = () => undefined,
    tabItems
  } = _ref;
  var [activeTabId, setActiveTabId] = useState(initialActiveTabId);

  var onTabClick = tab => {
    setActiveTabId(tab.id);
    onClick(tab);
  };

  return jsx(Style.TabsContainer, null, tabItems.map(tab => jsx(Style.TabItem, {
    active: tab.id === activeTabId,
    key: tab.id,
    onClick: () => {
      onTabClick(tab);
    }
  }, tab.text)));
};

export { Tabs };
